// Global file

// Captch Alt - SEO
const captchaImg = document.querySelector('.capcha img');

if (captchaImg) {
    captchaImg.alt = 'Captcha';
}

// IF THERE IS NO IMAGE
$('img').on('error', function(){ 
    $(this).attr('src', '/images/no-image.jpg');
});